import { ApplicationConfig } from '@angular/core';
import { importProvidersFrom } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateStore, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  bootstrapBriefcase,
  bootstrapBriefcaseFill,
  bootstrapCheckCircleFill,
  bootstrapChevronDown,
  bootstrapFacebook,
  bootstrapGeoAltFill,
  bootstrapGlobe2,
  bootstrapHeart,
  bootstrapInstagram,
  bootstrapMailbox,
  bootstrapMoonFill,
  bootstrapSearch,
  bootstrapSunFill,
  bootstrapTwitter,
} from '@ng-icons/bootstrap-icons';
import {
  heroBars3,
  heroChevronDoubleRight,
  heroChevronLeft,
  heroChevronRight,
  heroXMark,
} from '@ng-icons/heroicons/outline';
import { provideIcons } from '@ng-icons/core';

export const blogConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      ReactiveFormsModule,
      HttpClientModule,
      TranslateModule.forChild({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      })),
      provideIcons({
            bootstrapBriefcase,
            bootstrapBriefcaseFill,
            bootstrapCheckCircleFill,
            bootstrapChevronDown,
            bootstrapFacebook,
            bootstrapGeoAltFill,
            bootstrapGlobe2,
            bootstrapHeart,
            bootstrapInstagram,
            bootstrapMailbox,
            bootstrapMoonFill,
            bootstrapSearch,
            bootstrapSunFill,
            bootstrapTwitter,
            heroBars3,
            heroXMark,
            heroChevronDoubleRight,
            heroChevronLeft,
            heroChevronRight,
          }),
    TranslateStore,
  ]
};

export function httpLoaderFactory(_http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(_http, './assets/i18n/blog/blog-', '.json');
}
